// Alleen op desktop: de SVG-turbulence + mix-blend-mode over het volledige scherm is duur om te rasteren op mobiel.
export default function NoiseOverlay() {
  return <div className="noise-overlay hidden md:block" aria-hidden="true" data-testid="noise-overlay" />;
}
